export const BANK_TRANSFER = 'DISCO-engines-bank-transfer';
export const BED_ARRANGEMENT = 'DISCO-bed-arrangement';
export const HOUSE_RULES = 'DISCO-house-rules';
export const CREDIT_CARD_USAGE = 'CreditCardReusage';
export const NEW_TRANSLATIONS_UI = 'DISCO-engines-translations';
export const SHOW_NO_PROPERTIES_PAGE = 'DISCO-BEP-show-no-properties-page';
export const PRICE_FILTER_FIX = 'DISCO-BE-nightly-rates-filter';
export const FORCE_THUMBNAIL_WORKAROUND = 'DISCO-BE-thumbnail-workaround';
export const ZERO_AMOUNT_NOTIFICATION = 'CMGZeroAmountNotification';
